import * as React from 'react';

export const MdxTable: React.FC<React.TableHTMLAttributes<HTMLTableElement>> = (props) => (
  <div data-content-table>
    <table {...props} />
  </div>
);
